module.exports = __webpack_public_path__ + "img/com.smarthome.core.main.36ba3d34.webp";